module.exports = __webpack_public_path__ + "static/media/OW5.0545646c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OW/OW5.png
// module id = 724
// module chunks = 0